import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        cardmachinerecordarr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_CARDMACHINERECORDLIST: (state, obj) => {

            state.total = obj.total
            state.cardmachinerecordarr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.cardmachinerecordarr.splice(index,1)
        },
        CLEAR_CARDMACHINERECORDLIST: (state) => {

            state.total = 0
            state.cardmachinerecordarr=[]

        },


    },
    actions: {
        async getCardmachinerecordlist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getcardmachinerecordlist(params)
            if (code == 200) {
                commit('SET_CARDMACHINERECORDLIST', data);
           
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}